import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const insomnia = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
